import { Action } from '@ngrx/store';
import { BlacklistRequest, ImportFile } from './blacklist';

export const GET_BLACKLIST = 'GET_BLACKLIST';
export const GET_BLACKLIST_SUCCESS = 'GET_BLACKLIST_SUCCESS';
export const GET_BLACKLIST_FAILURE = 'GET_BLACKLIST_FAILURE';
export const GET_INFO_IN_BLACKLIST = 'GET_INFO_IN_BLACKLIST';
export const GET_INFO_IN_BLACKLIST_SUCCESS = 'GET_INFO_IN_BLACKLIST_SUCCESS';
export const GET_INFO_IN_BLACKLIST_FAILURE = 'GET_INFO_IN_BLACKLIST_FAILURE';
export const EXPAND_MSISDN = 'EXPAND_MSISDN';
export const CLEAR_INFO_IN_BLACKLIST = 'CLEAR_INFO_IN_BLACKLIST';
export const ADD_NUMBERS_TO_BLACKLIST = 'ADD_NUMBERS_TO_BLACKLIST';
export const ADD_NUMBERS_TO_BLACKLIST_SUCCESS = 'ADD_NUMBERS_TO_BLACKLIST_SUCCESS';
export const ADD_NUMBERS_TO_BLACKLIST_FAILURE = 'ADD_NUMBERS_TO_BLACKLIST_FAILURE';
export const REMOVE_NUMBERS_TO_BLACKLIST = 'REMOVE_NUMBERS_TO_BLACKLIST';
export const REMOVE_NUMBERS_TO_BLACKLIST_SUCCESS = 'REMOVE_NUMBERS_TO_BLACKLIST_SUCCESS';
export const REMOVE_NUMBERS_TO_BLACKLIST_FAILURE = 'REMOVE_NUMBERS_TO_BLACKLIST_FAILURE';
export const IMPORT_FILE_TO_BLACKLIST = 'IMPORT_FILE_TO_BLACKLIST';
export const IMPORT_FILE_TO_BLACKLIST_SUCCESS = 'IMPORT_FILE_TO_BLACKLIST_SUCCESS';
export const IMPORT_FILE_TO_BLACKLIST_FAILURE = 'IMPORT_FILE_TO_BLACKLIST_FAILURE';

export class GetBlacklistAction implements Action {
  readonly type = GET_BLACKLIST;

  constructor(public payload: BlacklistRequest) {}
}

export class GetBlacklistSuccessAction implements Action {
  readonly type = GET_BLACKLIST_SUCCESS;

  constructor(public payload) {}
}

export class GetBlacklistFailureAction implements Action {
  readonly type = GET_BLACKLIST_FAILURE;

  constructor(public payload) {}
}

export class GetInfoInBlacklistAction implements Action {
  readonly type = GET_INFO_IN_BLACKLIST;

  constructor(public payload) {}
}

export class GetInfoInBlacklistSuccessAction implements Action {
  readonly type = GET_INFO_IN_BLACKLIST_SUCCESS;

  constructor(public payload) {}
}

export class GetInfoInBlacklistFailureAction implements Action {
  readonly type = GET_INFO_IN_BLACKLIST_FAILURE;

  constructor(public payload) {}
}

export class ExpandMsisdnAction implements Action {
  readonly type = EXPAND_MSISDN;

  constructor(public payload) {}
}

export class ClearInfoInBlacklistAction implements Action {
  readonly type = CLEAR_INFO_IN_BLACKLIST;

  constructor(public payload) {}
}

export class AddNumbersToBlacklistAction implements Action {
  readonly type = ADD_NUMBERS_TO_BLACKLIST;

  constructor(public payload) {}
}

export class AddNumbersToBlacklistSuccessAction implements Action {
  readonly type = ADD_NUMBERS_TO_BLACKLIST_SUCCESS;

  constructor(public payload) {}
}

export class AddNumbersToBlacklistFailureAction implements Action {
  readonly type = ADD_NUMBERS_TO_BLACKLIST_FAILURE;

  constructor(public payload) {}
}

export class RemoveNumbersToBlacklistAction implements Action {
  readonly type = REMOVE_NUMBERS_TO_BLACKLIST;

  constructor(public payload) {}
}

export class RemoveNumbersToBlacklistSuccessAction implements Action {
  readonly type = REMOVE_NUMBERS_TO_BLACKLIST_SUCCESS;

  constructor(public payload) {}
}

export class RemoveNumbersToBlacklistFailureAction implements Action {
  readonly type = REMOVE_NUMBERS_TO_BLACKLIST_FAILURE;

  constructor(public payload) {}
}

export class ImportFileToBlacklistAction implements Action {
  readonly type = IMPORT_FILE_TO_BLACKLIST;

  constructor(public payload: ImportFile) {}
}

export class ImportFileToBlacklistSuccessAction implements Action {
  readonly type = IMPORT_FILE_TO_BLACKLIST_SUCCESS;

  constructor(public payload) {}
}

export class ImportFileToBlacklistFailureAction implements Action {
  readonly type = IMPORT_FILE_TO_BLACKLIST_FAILURE;

  constructor(public payload) {}
}

export type Actions =
  | GetBlacklistAction
  | GetBlacklistSuccessAction
  | GetBlacklistFailureAction
  | GetInfoInBlacklistAction
  | GetInfoInBlacklistSuccessAction
  | GetInfoInBlacklistFailureAction
  | ExpandMsisdnAction
  | ClearInfoInBlacklistAction
  | AddNumbersToBlacklistAction
  | AddNumbersToBlacklistSuccessAction
  | AddNumbersToBlacklistFailureAction
  | RemoveNumbersToBlacklistAction
  | RemoveNumbersToBlacklistSuccessAction
  | RemoveNumbersToBlacklistFailureAction
  | ImportFileToBlacklistAction
  | ImportFileToBlacklistSuccessAction
  | ImportFileToBlacklistFailureAction;
